import { createSlice } from "@reduxjs/toolkit";
export const sessionSlice = createSlice({
  name: "auth/session",
  initialState: {
    token: "",
    cta: "",
    signedIn: false,
    isSendOtp: false,
    isVarifyOtp: false,
    req_id: "",
    isStoredeviceinformation: false,
    toggleStoreDevicePopUp: false,
    userData: "",
    user_id: "",
  },
  reducers: {
    onSignInSuccess: (state, action) => {
      state.signedIn = true;
      state.token = action.payload.token;
      state.cta = action.payload.cta;
    },
    onSendOtpSuccess: (state, action) => {
      state.isSendOtp = action.payload;
    },
    onVarifyOtpSuccess: (state, action) => {
      state.signedIn = true;
      state.isVarifyOtp = true;
      state.token = action.payload.token;
      state.cta = action.payload.cta;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = "";
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
    setUserTemp: (state, action) => {
      state.userData = action.payload;
    },
    setToggleDevicePopUp: (state, action) => {
      state.toggleStoreDevicePopUp = action.payload;
    },
    setReq_id: (state, action) => {
      state.req_id = action.payload;
    },
    setNav: (state, action) => {
      state.nav = action.payload;
    },
    setCta: (state, action) => {
      state.cta = action.payload;
    },
  },
});

export const {
  onSignInSuccess,
  onSignOutSuccess,
  setToken,
  setCta,
  onSendOtpSuccess,
  onVarifyOtpSuccess,
  setReq_id,
  setToggleDevicePopUp,
  setUserTemp,
  setUserId,
} = sessionSlice.actions;

export default sessionSlice.reducer;
